import Vue from 'vue'
import Router from 'vue-router'
import CreativeDemoView from '@/components/CreativeDemoView.vue'
import DemoView from '@/components/DemoView.vue'
import EnhancedDemoView from '@/components/EnhancedDemoView.vue'
import HomeView from '@/components/HomeView.vue'
import LearnMoreView from '@/components/LearnMoreView.vue'
import RootView from '@/components/RootView.vue'
import WorkPreviewView from '@/components/WorkPreviewView.vue'
import WorkReadyView from '@/components/WorkReadyView.vue'
import WorksSelectionView from '@/components/WorksSelectionView.vue'

import firebase from 'firebase/app';
import 'firebase/firestore'; // Imported for sideeffects.

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },  
  routes: [
    {
      path: '/',
      redirect: () => {
        const locale = window.$cookies.get('locale');
        if (locale === 'en') {
          return '/en';
        } else {
          return '/de';
        }
      }
    },
    {
      path: '/:lang',
      component: RootView,
      children: [
        {
          path: '',
          name: 'home',
          component: HomeView,
          children: [
            {
              path: 'demo',
              name: 'demo',
              component: DemoView
            },
            {
              path: 'learn-more',
              name: 'learn-more',
              component: LearnMoreView
            },
            {
              path: 'creative-demo',
              name: 'creative-demo',
              component: CreativeDemoView
            },
            {
              path: 'enhanced-demo',
              name: 'enhanced-demo',
              component: EnhancedDemoView
            },
            {
              path: 'work-preview/:id',
              name: 'work-preview',
              component: WorkPreviewView
            },
          ]
        },
        {
          path: 'works-selection/:tags',
          name: 'works-selection',
          component: WorksSelectionView
        },
        {
          path: 'work-ready/:id',
          name: 'work-ready',
          component: WorkReadyView
        }
      ]
    },
    {
      path: '/admin/manage-works',
      name: 'manage-works',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "admin" */ './components/admin/ManageWorksView.vue'),
      meta: {
        auth: true,
      }
    },
  ]
})

// Preload lazy-loaded Admin parts for easy Cypress testing.
if (process.env.VUE_APP_INSIDE_E2E_TEST) {
  import( /* webpackChunkName: "admin" */ './components/admin/ManageWorksView.vue');
}

router.beforeEach((to, from, next) => {
  // Do not test Firebase auth in e2e-tests.
  if (process.env.VUE_APP_INSIDE_E2E_TEST) {
    next();
    return;
  }

  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithRedirect(provider)
        next(false);
      } else {
        next()
      }
    });
  } else {
    next()
  }
})

export default router;